import React from "react";
import {useSearchParams} from "react-router-dom";
import {Box, Tab, Tabs} from "@mui/material";
import FormsPage from "./FormsPage.js";
import PrestationsPage from "./PrestationsPage.js";
import ProblemsPage from "./ProblemsPage.js";
import ConsignesPage from "./ConsignesPage.js";
import ModesOperatoiresPage from "./ModesOperatoiresPage.js";
import ActesPage from "./ActesPage.js";
import AgencesPage from "./AgencesPage.js";

/**
 * Hub « Référentiel » : regroupe la gestion des données de configuration sous une
 * seule entrée de menu, via une sous-navigation par onglets (synchronisée à l'URL
 * ?tab=). Chaque onglet réutilise la page CRUD existante telle quelle.
 * Ajouter un catalogue = ajouter une entrée ici (zéro entrée de menu en plus).
 */
const TABS = [
    {key: "formulaires", label: "Formulaires", render: () => <FormsPage/>},
    {key: "prestations", label: "Prestations & typologies", render: () => <PrestationsPage/>},
    {key: "problemes", label: "Problèmes", render: () => <ProblemsPage/>},
    {key: "consignes", label: "Consignes", render: () => <ConsignesPage/>},
    {key: "modes-operatoires", label: "Modes opératoires", render: () => <ModesOperatoiresPage/>},
    {key: "actes", label: "Actes", render: () => <ActesPage/>},
    {key: "agences", label: "Agences", render: () => <AgencesPage/>},
];

export default function ReferentielPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const current = searchParams.get("tab") || TABS[0].key;
    const activeIndex = Math.max(0, TABS.findIndex((t) => t.key === current));

    const handleChange = (_e, idx) => setSearchParams({tab: TABS[idx].key});

    return (
        <Box>
            <Tabs
                value={activeIndex}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{borderBottom: 1, borderColor: "divider", mb: 2}}
            >
                {TABS.map((t) => <Tab key={t.key} label={t.label}/>)}
            </Tabs>

            {TABS[activeIndex].render()}
        </Box>
    );
}
